import { Box, Image } from '@everlywell/ui-kit';
import { SectionHeader } from 'components/SectionHeader';
import React from 'react';

type IImageSection = {
  title: string;
  headline: string;
  sectionImage: {
    url: string;
    title: string;
  };
};

const ImageSection = ({ title, headline, sectionImage }: IImageSection) => (
  <Box py={['3rem', '4rem', '4rem']}>
    <SectionHeader eyebrow={title} title={headline} titleMaxWidth="800px" />
    <Image
      src={sectionImage.url}
      alt={sectionImage.title}
      width="100%"
      maxWidth="976px"
      mx="auto"
      mt={12}
    />
  </Box>
);

export default ImageSection;
